<div>
  <div class="row col-12 gestion-container">
    <h3 class="mb-2 title-section"> Perfilado de módulos </h3>
    <!-- MAIN CARD -->
    <form 
      class="f-group" 
      [formGroup]="profileForm" 
      (ngSubmit)="saveProfileChanges(); saveContentCorporate(corporateProfile)"
    >
      <div class="row col-12">
        <!-- COLUMNA 1 -->
        <div class="mt-4 col-4" *ngIf="step === 1">
          <p> 
            1. Nombra el perfil de una manera sencilla de relacionar con los permisos que
            le otorgarás a los puestos que selecciones. Ejemplo: Directivos.
          </p>
          <div class="col-12">
            <label for="name"> Nombre del perfil </label>
            <input 
              matInput 
              formControlName="name" 
              maxlength="50" 
              type="text" 
              id="name" 
              class="form-control"
              (keyup)="onChangeTitle()"
            />
            <div class="count-div d-flex justify-content-end">
              <div> {{ titleText.length }}/50 </div>
            </div>
          </div>

          <p class="mt-4"> Puedes crear perfiles mediante un layout de id de los módulos </p>

          <!-- Carga Excel -->
          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <div ngbDropdown style="width: 220px;">
              <button type="button" class="btn toggle-button" id="cargaExcel" ngbDropdownToggle> Cargar Excel </button>
              <div ngbDropdownMenu aria-labelledby="cargaExcel">
                <button ngbDropdownItem type="button" (click)="downloadFile()"> Descargar formato </button>
                <input class="input-file" type="file" accept=".xlsx" (change)="dropAttachFiles($event);" #fileInput>
                <button ngbDropdownItem type="button" (click)="fileInput.click();"> Subir formato </button>
              </div>
            </div>
          </div>

          <!-- EXCEL TITULO -->
          <div class="col-12" *ngIf="onValidateExcel">
            <div class="col-8">
              <div class="btn-group mt-3" role="group" aria-label="Button group">
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-excel radius-btn-excel" disabled>
                    {{ fileName }}
                  </button>
                </div>
                <button type="button" class="btn btn-icon radius-btn-excel" (click)="cleanFile()">
                  <mat-icon class="icon-c-folder icon-display filter-red" svgIcon="icon-x"></mat-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- PREVIEW MODULOS CARGADOS -->
          <div class="card custom-inner-card mt-3" *ngIf="onValidateExcel">
            <div class="card-header">
              <div class="row">
                <div class="col-md-10">
                  <div class="row">
                    <div class="col-md-12">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body" style="overflow: auto; height: 270px;">
              <div class="row">
                <div class="col-md-12" style="padding-left: 8px;" *ngFor="let module of modulesListByExcel">
                  <!-- LIST TREE VIEW -->
                  <div class="row">
                    <img class="list-image" src="{{ module.urlIdPermission }}"/> 
                    {{ module.idPermission }} - {{ module.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- COLUMNA 2 -->
        <div class="mt-4 col-4" style="padding-right: 0px;" *ngIf="step === 1">
          <p>2. Selecciona los módulos que podrá visualizar el perfil que estás creando</p>
          <app-tree-view
            (selectedPermissions)="permissionsList = $event"
            (userPermissions)="onEditingPermissionsList = $event"
            (iconAvailableList)="iconAvailableList = $event"
            (moduleListService)="moduleListService = $event"
            (urlExcel)="urlExcel = $event"
            [onEditingProfile]="idEditingProfile"
          >  
          </app-tree-view>
        </div>
        <!--  ASINGACION DE FUNCIONES -->
        <div class="col-md-8 mt-4" *ngIf="step === 2">
          <app-asignacion-funciones
            [profileName]="profileForm.value.name"
            [profileUpdateInfo]="profileUpdateInfo"
            [userPermissions]="onEditingPermissionsList"
            [urlExcel]="urlExcel"
            (segmentationBySapFunctions)="segmentationBySapFunctions = $event"
            (selectedItemsList)="selectedFunctions = $event"
            (employeesArrayList)="employeesArrayList = $event"
            (jsonDataKey)="jsonDataKey = $event"
          >
          </app-asignacion-funciones>
        </div>
        <!--  COLUMNA 3 SMARTPHONE -->
        <div class="mt-4 col-4">
          <p *ngIf="step === 1">3. Previsualiza los módulos del perfil</p>
          <div class="col-md-10 offset-md-1">
            <app-modulos-asignados
              [stepId]="step"
              [iconAvailableList]="iconAvailableList"
            >
            </app-modulos-asignados>
          </div>
        </div>
      </div>
      <!--  FOOTER ASINGACION DE PERMISOS (MODULOS) -->
      <div class="pt-2 col-12 d-flex justify-content-end mt-3" *ngIf="step === 1">
        <button type="button" class="btn btn-return radius-btn" (click)="changeView('perfilado-empleados')">
          <strong style="padding-right: 5px;"> Regresar </strong>
        </button>
        <button 
          type="button" 
          class="btn btn-perfil radius-btn" 
          (click)="changeStep(2);" 
          [disabled]="!profileForm.valid"
        >
          <strong style="padding-right: 5px;"> Siguiente </strong>
          <mat-icon class="icon-c-folder icon-display" svgIcon="icon-arrow-right"></mat-icon>
        </button>
      </div>
      <!--  FOOTER ASINGACION DE FUNCIONES -->
      <div class="pt-2 col-12 d-flex justify-content-end mt-3" *ngIf="step === 2">
        <button type="button" class="btn btn-return radius-btn" (click)="changeStep(1)">
          <strong style="padding-right: 5px;"> Regresar </strong>
        </button>
        <button type="submit" class="btn btn-perfil radius-btn" [disabled]="!profileForm.valid">
          <strong style="padding-right: 5px;"> Guardar </strong>
        </button>
      </div>
    </form>

    <!-- MODAL PERFIL ASIGNADO CON EXITO -->
    <ng-template #corporateProfile let-modal>
      <div class="card-alert">
        <!-- Imagen -->
        <div class="col-md-6 offset-md-3 mt-4 text-center confirmation">
          <img class="warning-image" src="https://s3.amazonaws.com/dev.structure.files/assets/advertencia.png" />
          <h3 class="mt-2">Advertencia</h3>
        </div>
        <div class="col-md-8 offset-md-2">
          <p class="text-center alert-body mt-3">
            Por favor, tenga en cuenta que si un empleado es corporativo no se vera reflejado (Check In) 
          </p>
        </div>
        <!-- FOOTER -->
        <div class="pt-2 col-12 mt-3 mb-4 footer-modal">
          <button type="button" class="btn btn-cancel radius-btn" (click)="modal.close('Close click');">
            <strong style="padding-right: 5px;">Cancelar</strong>
          </button>
          <button type="button" class="btn btn-acept-modal radius-btn" (click)="modal.close('Close click'); modifyProfilePermissions(assingProfile)">
            <strong style="padding-right: 5px;">Aceptar</strong>
          </button>
        </div>
      </div>
    </ng-template>

    <!-- MODAL EDITAR PERFIL -->
    <ng-template #editProfile let-modal>
      <div class="card-alert">
        <!-- Imagen -->
        <div class="col-md-6 offset-md-3 mt-4 text-center confirmation">
          <img class="warning-image" src="https://s3.amazonaws.com/dev.structure.files/assets/advertencia.png" />
          <h3 class="mt-2">Advertencia</h3>
        </div>
        <div class="col-md-8 offset-md-2">
          <p class="text-center alert-body mt-3">
            ¿Estás seguro que quieres realizar los cambios?
          </p>
        </div>
        <!-- FOOTER -->
        <div class="pt-2 col-12 mt-3 mb-4 footer-modal">
          <button type="button" class="btn btn-cancel radius-btn" (click)="modal.close('Close click');">
            <strong style="padding-right: 5px;">Cancelar</strong>
          </button>
          <button type="button" class="btn btn-acept-modal radius-btn" (click)="deleteItem()">
            <strong style="padding-right: 5px;">Aceptar</strong>
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>